import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type MoveToCopyToProjectRowFragment = { __typename?: 'Project', id: string, name: string, private: boolean, archivedAt?: string | null, images: { __typename?: 'Images', image32?: string | null } };

export const MoveToCopyToProjectRow = /*#__PURE__*/ gql`
    fragment MoveToCopyToProjectRow on Project {
  id
  name
  private
  archivedAt
  images {
    image32
  }
}
    ` as unknown as DocumentNode<MoveToCopyToProjectRowFragment, unknown>;

        

        
export const useMoveToCopyToProjectRowFragment = (
  input: string | Omit<UseFragmentOptions<MoveToCopyToProjectRowFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<MoveToCopyToProjectRowFragment>({
    fragment: MoveToCopyToProjectRow,
    fragmentName: 'MoveToCopyToProjectRow',
    ...options,
  });
};
  
        